'use strict';

var component = angular.module('saturn.map.layer.popup', []);

var PopupDirective = require('./PopupDirective');

component.directive('sbMapLayerPopup', PopupDirective);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/popup/index.js